import {RouteLoader} from '@dofleini/security';
import React, {Suspense} from 'react';

import PageLoader from '@/components/PageLoader';

import routes from './routes.constant';

const ModuleRoutes = () => {
  return (
    <Suspense fallback={<PageLoader/>}>
      <RouteLoader routes={routes} notfoundRedirect={'/onboarding'}/>
    </Suspense>
  );
};

ModuleRoutes.propTypes = {};

ModuleRoutes.defaultProps = {};

export default ModuleRoutes;
